<template>
  <wt-close v-once class="wt2-sg" @click.native="onClick" />
</template>

<script>
import Vue from 'vue';
import EmbedmentController from '../../controllers/EmbedmentController';
import app from 'app';

export default Vue.extend({
  name: 'CloseEmbeddedModal',

  methods: {
    onClick: _.debounce(
      function () {
        app.storyController.save();
        EmbedmentController.confirmLeave().then((shouldRedirectToEntry) => {
          this.$_closeModal(shouldRedirectToEntry);
        });
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),

    $_closeModal(shouldRedirectToEntry) {
      window.parent &&
        window.parent.postMessage(
          {
            type: 'APPLICATION_EVENT',
            event: 'ABORT',
            payload: {
              externalStoryEntryId: shouldRedirectToEntry
                ? app.storyController.story.get('_externalStoryEntryId')
                : false,
            },
          },
          '*'
        );
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt2-close {
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding: 17px;
  cursor: pointer;
  &:hover {
    background-color: $color-black-l2;
  }
}
</style>
